// Reducer for loading user data for use in API endpoints

const userInfoReducerDefaultState = {
    userName        : "",
    searchTimestamp : undefined
};

export default (state = userInfoReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_USERNAME' :
            return {
                ...state,
                userName : action.userName
            };
        case 'SET_SEARCH_TIMESTAMP' :
            return {
                ...state,
                searchTimestamp : action.searchTimestamp
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/Reducers/userInfo.js